[
  {
    "id": "rivergate_chart_roads",
    "speaker": "Rivergate Road-Wardens",
    "lines": [
      {
        "id": "rivergate_chart_roads_1",
        "text": "The road-wardens keep a back room full of charts no heartland map bothers with — the mountain passes to Stonehall, the forest tracks into Greenveil, the tower-road to the Sevenfold spires, the steppe trails to the nomad camps, the pilgrim way to the Whispering Lake. You spend two days copying what matters. The far country is no longer a rumour with a direction; it is a set of roads you could actually walk."
      }
    ]
  },
  {
    "id": "stonehall_introduce",
    "speaker": "Thane Durn of Stonehall",
    "lines": [
      {
        "id": "stonehall_introduce_1",
        "text": "The Thane hears you out from a chair carved into the mountain itself. \"A human, come all this way to ask us to march. You've courage, or you've no idea what you're asking.\" He grunts, which from a dwarf is nearly welcome. \"You're remembered here now, for what that's worth. It's worth this much: come back when you've something worth a Thane's time.\""
      }
    ]
  },
  {
    "id": "stonehall_giant_road",
    "speaker": "Thane Durn of Stonehall",
    "lines": [
      {
        "id": "stonehall_giant_road_1",
        "text": "\"The passes into Colossus Vale?\" Durn's eyes narrow. \"We've walked them to war more times than the kingdom's been alive. You go up through Emberforge and climb until the air thins and the walkers get big. I'll not stop you — but take dwarves, or take a burial.\" He has one of his wrights sketch you the road."
      }
    ]
  },
  {
    "id": "emberforge_broker_feud",
    "speaker": "Emberforge Forgemasters",
    "lines": [
      {
        "id": "emberforge_broker_feud_1",
        "text": "The debt of iron between Emberforge and Stonehall is a generation old and nobody now living remembers the weight of it exactly — only that neither hall will name it first. You spend two days doing what neither side would: putting the ledgers side by side. The debt, it turns out, was paid twice and recorded once. The forgemasters go very quiet, and then a rider is sent to the Thane with an apology a generation late."
      }
    ]
  },
  {
    "id": "stonehall_earn_trust",
    "speaker": "Thane Durn of Stonehall",
    "lines": [
      {
        "id": "stonehall_earn_trust_1",
        "text": "\"Emberforge sent a rider,\" Durn says, and there is something in his face that has not been there in twenty years. \"You settled a thing I'd given up settling. The clans will march for that.\" He stands, which for a Thane is a formality of enormous weight. \"Shieldbearers are mustering below. They're yours to lead — use them where a wall or a giant needs breaking.\""
      }
    ]
  },
  {
    "id": "stonehall_subject",
    "speaker": "Thane Durn of Stonehall",
    "lines": [
      {
        "id": "stonehall_subject_1",
        "text": "\"I've watched you make your case in three halls and win all three,\" Durn says. \"A dwarf knows when he's outmatched at the one thing he thought he was good at, and I was good at stubbornness.\" He sets his hammer across your hands and takes it back — the old oath of a host given. \"Hammerguard and the guns are yours as well. Point us at the mountain that needs coming down.\""
      }
    ]
  },
  {
    "id": "thornwatch_introduce",
    "speaker": "Thornwatch Rangers",
    "lines": [
      {
        "id": "thornwatch_introduce_1",
        "text": "The rangers are already watching you before you see them, which is the whole point of them. \"You walked in from the Aerie without us marking you until the last mile. That's not nothing.\" Their captain drops from a branch you'd have sworn was empty. \"Sylvaine holds court at Greenveil. We'll not vouch for you yet — but we'll not shoot you either, and out here that's an introduction.\""
      }
    ]
  },
  {
    "id": "greenveil_darkelf_road",
    "speaker": "Warden Sylvaine of Greenveil",
    "lines": [
      {
        "id": "greenveil_darkelf_road_1",
        "text": "\"The Nightweb.\" Sylvaine says the word the way you'd handle a knife by the blade. \"Our estranged kin, who went down into the dark and stayed. The way in runs south, past the Red Steppe, into a warren that hides its own doorways.\" She has a scout mark it for you. \"Take someone who can find what does not want finding. Take us, if you can earn it.\""
      }
    ]
  },
  {
    "id": "elderroot_win_argument",
    "speaker": "The Elders of Elderroot Grove",
    "lines": [
      {
        "id": "elderroot_win_argument_1",
        "text": "The elders would keep the forest whole and let the outer kingdoms burn, and they have a hundred years of precedent for it. You answer them with their own history: every age the forest tried to stand apart, and every age the fire found it anyway, one border further in than the last. It takes a day of it. In the end an elder older than the kingdom inclines her head. \"The young ones may march,\" she says. \"You have reminded us that a wall is not the same as a shore.\""
      }
    ]
  },
  {
    "id": "greenveil_earn_trust",
    "speaker": "Warden Sylvaine of Greenveil",
    "lines": [
      {
        "id": "greenveil_earn_trust_1",
        "text": "\"Elderroot has released the young ones, and Thornwatch has stopped straining against a leash that's no longer there,\" Sylvaine says. \"You did that. I did not think it could be done this decade.\" She whistles once, and pathfinders and longbows step out of a treeline that looked empty. \"They're yours. Use them to drag the Nightweb into the light where it can be fought.\""
      }
    ]
  },
  {
    "id": "greenveil_subject",
    "speaker": "Warden Sylvaine of Greenveil",
    "lines": [
      {
        "id": "greenveil_subject_1",
        "text": "\"The rangers follow the forest, and the forest has decided it follows you,\" Sylvaine says, which from a Wood Elf is close to a coronation. \"The Thornguard as well, then — the ones who stand and hold. Lead the whole wood, and lead it somewhere that matters.\""
      }
    ]
  },
  {
    "id": "sevenfold_introduce",
    "speaker": "Archmagister Vaeloth",
    "lines": [
      {
        "id": "sevenfold_introduce_1",
        "text": "Vaeloth receives you in a room that is seven rooms at once, the spires braided into each other by more than architecture. \"A visitor who reached the Tower without an appointment. Rare.\" The Archmagister studies you the way one reads an unfamiliar hand. \"You'll find us divided, and you'll find both halves certain. Whether you can do anything about that is another question — but you are welcome to try, now that I know your face.\""
      }
    ]
  },
  {
    "id": "rift_observatory_demon_road",
    "speaker": "The Rift Observatory",
    "lines": [
      {
        "id": "rift_observatory_demon_road_1",
        "text": "The fire-handlers turn their great lens south and east until the Shattered Veil sits in the crosshair — a tear in the world with something patient on the far side of it. \"There,\" one says. \"You can reach it across the wastes from here, or up from the Red Steppe. Fix the bearing in your memory. Do not go without someone who can unmake a binding, or you will only be feeding it.\""
      }
    ]
  },
  {
    "id": "glass_library_reconcile_orders",
    "speaker": "The Two Orders of the Tower",
    "lines": [
      {
        "id": "glass_library_reconcile_orders_1",
        "text": "The ritualists of the Glass Library believe the fire-handlers' recklessness will doom the world; the fire-handlers of the Observatory believe the ritualists' caution will let it be doomed. You spend two days laying the true history of the threat between them — the anchors and the rifts, the ritual counting down to the five hundred and twelfth day — until both orders see they have been describing the same monster from opposite sides. Unmaking and burning, it turns out, are the same war fought with different hands."
      }
    ]
  },
  {
    "id": "sevenfold_earn_trust",
    "speaker": "Archmagister Vaeloth",
    "lines": [
      {
        "id": "sevenfold_earn_trust_1",
        "text": "\"You made two orders that have not agreed in a century agree in an afternoon,\" Vaeloth says. \"I have decided not to be offended by that.\" The Archmagister gestures, and Ritual Mages and Flame Guard fall in together — a sight the Tower has not shown in living memory. \"They are yours. The Mages to unmake anchors and rifts, the Guard to make a troll's wound stay a wound. Do not waste either on the wrong enemy.\""
      }
    ]
  },
  {
    "id": "sevenfold_subject",
    "speaker": "Archmagister Vaeloth",
    "lines": [
      {
        "id": "sevenfold_subject_1",
        "text": "\"The Tower answers to no crown,\" Vaeloth says, \"but it will answer to the one argument it cannot refute, which is the sun going out. You have made that argument better than I could.\" The braided spires seem to lean toward you. \"The Storm Callers as well. The whole Tower is yours to spend — spend it on the binding that matters most.\""
      }
    ]
  },
  {
    "id": "whispering_lake_introduce",
    "speaker": "The Pale Sister",
    "lines": [
      {
        "id": "whispering_lake_introduce_1",
        "text": "The Pale Sister stands at the water's edge where the living and the dead are only a hand's breadth apart. \"You have the mark of someone who dies and does not stay dead,\" she says, without turning. \"We know that kind of unquiet here. Sit. Be known. There is a house divided behind me, and until it is one voice I can promise you nothing but a watch kept.\""
      }
    ]
  },
  {
    "id": "whispering_lake_undead_road",
    "speaker": "The Pale Sister",
    "lines": [
      {
        "id": "whispering_lake_undead_road_1",
        "text": "\"The Ashen Necropolis.\" The Sister's reflection does not quite match her. \"A city of the standing dead, held up by an anchor driven into old ground. The way there runs south from the Hall of Ancestors, through country the living seldom keep. Throw down the anchor and you do not slaughter an army — you let one lie down. Remember that when you go.\""
      }
    ]
  },
  {
    "id": "hall_ancestors_reconcile",
    "speaker": "The Hall of Ancestors",
    "lines": [
      {
        "id": "hall_ancestors_reconcile_1",
        "text": "The shades in the Hall want the Necromancer's dead unmade to the last splinter of bone; the living wardens want them laid to rest with mercy. You stand in the cold between them and find the seam: that unmaking the anchor and granting rest are, in fact, the same act — the anchor is the cruelty, the bodies are only its victims. The dead consider this in their slow way, and the argument goes out of the Hall like a held breath released."
      }
    ]
  },
  {
    "id": "whispering_lake_earn_trust",
    "speaker": "The Pale Sister",
    "lines": [
      {
        "id": "whispering_lake_earn_trust_1",
        "text": "\"The Hall speaks with one voice now, and it speaks your name,\" the Sister says. \"Mercy and unmaking, reconciled — I did not think a living hand could do it.\" Pale figures gather at the water: Spirit Wardens who fight what cannot be cut, and Ancestor Shades who see what hides. \"They will go with you. Spend them on the dead and the possessed, where nothing else will serve.\""
      }
    ]
  },
  {
    "id": "whispering_lake_subject",
    "speaker": "The Pale Sister",
    "lines": [
      {
        "id": "whispering_lake_subject_1",
        "text": "\"The dead do not enlist,\" the Sister says. \"But they will follow a living thing that has proven it understands rest as well as ruin.\" The brightest of the watchers, a Radiant Seraph, inclines toward you like sunlight finding a gap. \"Take it, and all of us with it. Bring us to the anchor that holds the most of our kin, and let us put them down gently.\""
      }
    ]
  },
  {
    "id": "camp_introduce",
    "speaker": "Khan Aytolga",
    "lines": [
      {
        "id": "camp_introduce_1",
        "text": "Aytolga meets you between two of the seven banners, and only two of them are hers. \"You rode in without an escort and without getting lost. On the steppe that is a letter of introduction.\" She looks you over from the saddle. \"We are seven clans and no Khan the other six will follow, and until that is settled we are a great many horses and no army. Come back when you have something to offer a camp that cannot agree what day it is.\""
      }
    ]
  },
  {
    "id": "camp_troll_road",
    "speaker": "Khan Aytolga",
    "lines": [
      {
        "id": "camp_troll_road_1",
        "text": "\"The Mire of Hunger?\" Aytolga spits. \"A wet grave that eats what wanders in. The riders know the firm ground through it — west of the camp, where the reeds stop being green.\" She has an outrider cut you a path in the dirt with a knife. \"The things in there mend every wound but a burned one. Bring fire, or bring nothing worth losing.\""
      }
    ]
  },
  {
    "id": "windroad_broker_succession",
    "speaker": "The Seven Banners",
    "lines": [
      {
        "id": "windroad_broker_succession_1",
        "text": "Seven clans, seven claims, and a market that has been arguing the succession for a season without anyone drawing a blade — which is itself a kind of miracle you decide not to spend carelessly. You spend two days at it instead, until you find the shape none of them could see from inside it: not one Khan over six, but one war-leader the other six lend their banners to for the length of one war, and take them back after. It is the oldest trick on the steppe and none of them had dared say it first. Aytolga is chosen by sundown."
      }
    ]
  },
  {
    "id": "camp_earn_trust",
    "speaker": "Khan Aytolga",
    "lines": [
      {
        "id": "camp_earn_trust_1",
        "text": "\"Six banners lent me their standards because a stranger showed them how to do it without losing face,\" Aytolga says, and there is a grudging music in it. \"The horse archers and the outriders are yours to ride with. The archers to wear a line thin from a distance; the outriders to find what hides on open ground. Use them like a nomad would — never where they can be caught.\""
      }
    ]
  },
  {
    "id": "camp_subject",
    "speaker": "Khan Aytolga",
    "lines": [
      {
        "id": "camp_subject_1",
        "text": "\"The Seven Banners ride under one war-leader now, and I have decided it may as well be under yours,\" Aytolga says. \"The lancers too — the weight we keep back until the archers have done their work.\" She clasps your forearm, rider to rider. \"Take the whole steppe. There is a great deal of world between the clans and the citadel, and we cross ground others cannot.\""
      }
    ]
  },
  {
    "id": "cloudwood_dragon_road",
    "speaker": "The Watchers of Cloudwood Aerie",
    "lines": [
      {
        "id": "cloudwood_dragon_road_1",
        "text": "The watchers turn their long glasses west, past the cloud line, to where a red glow sits on a broken peak. \"Cinderpeak,\" one says. \"Vharethyx's roost. There is a climbing road from here to the ash slopes — few take it and fewer return.\" They mark it for you. \"Scale turns steel and fire is a dragon's mother tongue. Only massed archery has ever answered one. We would know; we have trained for it since before your kingdom had a name.\""
      }
    ]
  },
  {
    "id": "assault_blacktooth",
    "speaker": "The Blacktooth Wastes",
    "lines": [
      {
        "id": "assault_blacktooth_1",
        "text": "The whole war-camp is drawn up below you — not a raiding party this time but the muster itself, drums and banners and more orcs than any border needs. They are only ever dangerous while they believe they are winning. You mean to disabuse them of it quickly, before their nerve has a chance to settle."
      }
    ]
  },
  {
    "id": "blacktooth_expose",
    "speaker": "The Blacktooth Wastes",
    "lines": [
      {
        "id": "blacktooth_expose_1",
        "text": "You do not draw. You walk into the war-camp with the proof in your hands — the rift they opened and could never have opened alone, the mark of the hand that armed them and pointed them west. You put it in front of the warchief where the whole camp can hear. Orcs understand being used the way they understand a blade turned in a wound. The drums stop. When they start again, they are not beating toward the kingdom. They are beating toward whatever opened that rift."
      }
    ]
  },
  {
    "id": "assault_colossus_vale",
    "speaker": "Colossus Vale",
    "lines": [
      {
        "id": "assault_colossus_vale_1",
        "text": "Jarnsmiter's warband walks a valley too big for it to have ever needed caution. Steel skids off them; reaching them at all is the problem. But dwarves have fought giants at the knees since before the kingdom drew breath, and you did not come up the passes without them."
      }
    ]
  },
  {
    "id": "colossus_vale_peace",
    "speaker": "Jarnsmiter, Eldest of Colossus Vale",
    "lines": [
      {
        "id": "colossus_vale_peace_1",
        "text": "The dwarves at your side do not raise their hammers. They raise a name — an old peace, kept between mountain and vale before a debt of iron soured it, recited in a tongue Jarnsmiter has not heard spoken by a small folk in an age. The Eldest crouches to hear it, slow as weather. When the recitation is done he does not attack. He steps aside, and the pass to the citadel's shoulder is open, and a feud older than the kingdom has ended instead of a people."
      }
    ]
  },
  {
    "id": "assault_cinderpeak",
    "speaker": "Cinderpeak",
    "lines": [
      {
        "id": "assault_cinderpeak_1",
        "text": "Vharethyx uncoils off the ash slope with its brood behind it, and the heat of it reaches you before the shadow does. Scale turns steel and fire is only more fire to a dragon. You have brought the one answer anyone has ever found — arrows, and a great many of them, loosed all at once at a thing that thought itself beyond arrows."
      }
    ]
  },
  {
    "id": "cinderpeak_bargain",
    "speaker": "Vharethyx, the Ember of Cinderpeak",
    "lines": [
      {
        "id": "cinderpeak_bargain_1",
        "text": "You do not loose. You speak, which no one has troubled to do with a dragon in living memory, and you speak the one truth that touches even something that outlives kingdoms: the ritual will put out the sun, and a dragon is a creature of fire and light before it is a creature of anything. Vharethyx listens, enormous and cold. \"So the small necromancer would spend my sun to warm his grave,\" it says at last. \"No. I will burn what I choose to burn, and I do not choose his war. Go. You have bought nothing but my absence — but that was all you came for.\""
      }
    ]
  },
  {
    "id": "assault_mire_hunger",
    "speaker": "The Mire of Hunger",
    "lines": [
      {
        "id": "assault_mire_hunger_1",
        "text": "The Mire closes wet and hungry around the firm ground the nomads showed you, and the trolls rise out of it faster than they have any right to. Every wound you open on them closes while you watch. Only fire makes a wound stay a wound, and you have brought the Flame Guard to make the point permanently."
      }
    ]
  },
  {
    "id": "mire_hunger_pact",
    "speaker": "The Mother of the Mire",
    "lines": [
      {
        "id": "mire_hunger_pact_1",
        "text": "The Nomads go in ahead of the fire, driving a share of their own herds before them, and they speak to the Mother in the slow rhythm the Mire understands: not war, but a border and a tithe. The trolls only ever hunted because they were never once full. The Mother considers the offered herds with something almost like patience, and the hunger that would have marched on the kingdom settles back into its wet dark, fed and bounded. A famine, turned into a line on a map."
      }
    ]
  },
  {
    "id": "assault_ashen_necropolis",
    "speaker": "The Ashen Necropolis",
    "lines": [
      {
        "id": "assault_ashen_necropolis_1",
        "text": "The grey city stands, and every figure in it stands with it, held upright by the great anchor driven into the old ground at its heart. There is no army to defeat here, only a cruelty to end — throw down the anchor and the dead it holds up will finally be allowed to lie down. The Spirit Wardens at your side already know it. They have come to grant rest, and the rest looks a great deal like a battle from the outside."
      }
    ]
  },
  {
    "id": "assault_nightweb",
    "speaker": "The Nightweb Underrealm",
    "lines": [
      {
        "id": "assault_nightweb_1",
        "text": "The warren has no front and no ranks, only doorways that were not there a moment ago and killers who fight from a dark you cannot swing at. You did not come without eyes for it — pathfinders and outriders and the watching dead, anything that drags a Dark Elf into the light where it can be answered. Find them first, or do not fight them at all."
      }
    ]
  },
  {
    "id": "nightweb_buyout",
    "speaker": "Matron Vess of the Nightweb",
    "lines": [
      {
        "id": "nightweb_buyout_1",
        "text": "The Wood Elves go down into the dark to speak to their own estranged blood, and they carry an offer instead of a blade. The Dark Elves kill for coin and for coercion, never for conviction — and the Necromancer pays in the second currency, which no one keeps faith with once a better door opens. Matron Vess hears her forest-kin out from behind a curtain of shadow. \"Sentiment,\" she says, \"is expensive. But so is dying for a corpse who cannot pay. We are bought. Tell your Necromancer his knives have found other work.\""
      }
    ]
  },
  {
    "id": "assault_shattered_veil",
    "speaker": "The Shattered Veil",
    "lines": [
      {
        "id": "assault_shattered_veil_1",
        "text": "The tear hangs in the air like a wound that will not close, and things come through it faster than you could ever cut them down. You did not come to outlast the endless. You came to unmake the binding that holds the tear open — Ritual Mages on the anchor, Spirit Wardens holding the ground while they work. Seal it, and there is nothing left to fight."
      }
    ]
  },
  {
    "id": "ebon_citadel_behold",
    "speaker": "The Ebon Citadel",
    "lines": [
      {
        "id": "ebon_citadel_behold_1",
        "text": "So this is the wall at the end of every loop. The Ebon Citadel sits in the far corner of the world behind an army and a gate, and above it the sky is doing something the sky should not — a slow bruise spreading across the light, the ritual counting itself down toward the five hundred and twelfth day. You have reached it. Standing here, alive, at the end of every road you spent so many deaths learning, is its own kind of impossible. What is done inside is a war for a later day. That it can be reached at all is this day's whole victory."
      }
    ]
  },

  {
    "id": "ebon_citadel_open",
    "speaker": "The North Cistern",
    "lines": [
      {
        "id": "ebon_citadel_open_1",
        "text": "You do not go at the gate — it is an army thick, and pointed the wrong way for a reason; every assault the world remembers went there to die. The road past the sealed Veil brings you instead to the north cistern, a flooded service passage under the north wall, forgotten by everyone who ever tried the front. You wade it in the dark with the water at your chin and come up, dripping and unchallenged, inside the walls of the last stronghold in the world. Above you, through five hundred days of stone, you can hear the ritual like a held note. There is a way down to it now."
      }
    ]
  },
  {
    "id": "assault_ebon_citadel",
    "speaker": "The Ritual Chamber",
    "lines": [
      {
        "id": "assault_ebon_citadel_1",
        "text": "The stair goes down further than a building should allow, and it opens on the working itself — a wound in the air the size of a cathedral, and the Necromancer standing calm at the centre of it with every champion he ever kept and killed and kept again drawn up in front of him. He does not seem surprised. Perhaps, at the end of so many loops, nothing surprises him. He is warded against steel and arrow and flame alike; he is an anchor, and only holy light and the unmaking of bindings will reach him. Put the Seraph and the Wardens and the Ritual Mages on him and hold everything else off them — and be quick. The sky you can no longer see is nearly out."
      }
    ]
  },

  {
    "id": "blacktooth_stronghold_battle_victory",
    "speaker": "The Blacktooth Wastes",
    "lines": [
      {
        "id": "blacktooth_stronghold_battle_victory_1",
        "text": "The muster comes apart the way orc armies always come apart once they stop believing — all at once, and westward, back into the wastes they came from. The war-camp is cold fires and abandoned drums. Whatever the orcs were being built into, they will not be it this season.",
        "grantsKnowledge": ["resolved_orcs"]
      }
    ]
  },
  {
    "id": "colossus_vale_battle_victory",
    "speaker": "Colossus Vale",
    "lines": [
      {
        "id": "colossus_vale_battle_victory_1",
        "text": "The last of Jarnsmiter's warband goes down where the dwarves brought it down — at the knee, where giants have always fallen to the small folk who never learned to be afraid of size. The Vale is quiet. The passes to the citadel's shoulder are open, and there is one fewer thing walking the world that could close them behind you.",
        "grantsKnowledge": ["resolved_giants"]
      }
    ]
  },
  {
    "id": "cinderpeak_battle_victory",
    "speaker": "Cinderpeak",
    "lines": [
      {
        "id": "cinderpeak_battle_victory_1",
        "text": "Vharethyx falls out of the smoke with a sound like a mountain sitting down, feathered with more arrows than seems possible, and the ash slope takes it. The brood scatters west without their Ember to hold them. The oldest answer to the oldest terror held: enough archers, loosing as one, will bring down even a thing that thought itself beyond arrows.",
        "grantsKnowledge": ["resolved_dragons"]
      }
    ]
  },
  {
    "id": "mire_hunger_battle_victory",
    "speaker": "The Mire of Hunger",
    "lines": [
      {
        "id": "mire_hunger_battle_victory_1",
        "text": "Fire does what steel never could — the trolls that would have grown back every wound burn instead, and stay burned. The Mire steams and goes silent. The hunger that would have marched on the kingdom's harvests is a black scar on the reeds, and nothing rises out of it.",
        "grantsKnowledge": ["resolved_trolls"]
      }
    ]
  },
  {
    "id": "ashen_necropolis_battle_victory",
    "speaker": "The Ashen Necropolis",
    "lines": [
      {
        "id": "ashen_necropolis_battle_victory_1",
        "text": "The great anchor cracks, and then it is not holding anything upright any more. Across the grey city the standing dead sit down, lie down, and are finally only dead — no cruelty left in them, no hand on them, at rest. The Spirit Wardens move among them the way one moves through a house after a long illness has ended. There is grief in it, and no more fear.",
        "grantsKnowledge": ["resolved_undead"]
      }
    ]
  },
  {
    "id": "nightweb_battle_victory",
    "speaker": "The Nightweb Underrealm",
    "lines": [
      {
        "id": "nightweb_battle_victory_1",
        "text": "Dragged into the light, the Dark Elves are only elves after all — deadly, but findable, and a found killer is a beaten one. The warren empties of the fight in a single bad hour for Matron Vess. Her knives will not open the kingdom's throat in the dark this season; you made the dark give them back.",
        "grantsKnowledge": ["resolved_dark_elves"]
      }
    ]
  },
  {
    "id": "shattered_veil_battle_victory",
    "speaker": "The Shattered Veil",
    "lines": [
      {
        "id": "shattered_veil_battle_victory_1",
        "text": "The anchor comes apart under the Mages' unmaking, and the tear it held open folds shut with a sound like the world exhaling. What was already through dies without anything behind it to feed it. Where the Veil hung, there is only air now — and, beyond it, a clear road along the world's far edge to the last stronghold of all.",
        "grantsKnowledge": ["resolved_demon_spirits", "ebon_citadel_approach_known"]
      }
    ]
  }
]
